import { ErpSvg, ErpPath } from './ErpHtml';
import React from 'react';

export interface ErpSpinnerProps {
  type?: 'border' | 'grow';
  size?: 'small' | 'large';
  small?: boolean;
  label?: string;
  variant?: string;
  className?: string;
}

const _ErpSpinner: React.FC<ErpSpinnerProps> = ({
  type: _type = 'border',
  size,
  small,
  label,
  variant,
  className
}) => {
  const isSmall = small || size === 'small';
  const isLarge = size === 'large';

  const sizeClass = isSmall ? 'h-4 w-4' : isLarge ? 'h-8 w-8' : 'h-6 w-6';
  
  const variantMap: Record<string, string> = {
    primary: 'text-blue-600',
    secondary: 'text-slate-600',
    success: 'text-green-600',
    danger: 'text-red-600',
    error: 'text-red-600',
    warning: 'text-amber-600',
    info: 'text-blue-500',
    light: 'text-white',
    dark: 'text-slate-900',
  };
  const colorClass = variant ? (variantMap[variant] || 'text-current') : 'text-current';

  const classes = ['animate-spin', sizeClass, colorClass, className].filter(Boolean).join(' ');

  return (
    <ErpSvg 
      className={classes} 
      xmlns="http://www.w3.org/2000/svg" 
      fill="none" 
      viewBox="0 0 24 24"
      role="status"
      aria-label={label || 'Loading'}
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <ErpPath className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></ErpPath>
    </ErpSvg>
  );
};

export const ErpSpinner = React.memo(_ErpSpinner);
